/*
  Keeps the LoudCrowd shop-with carousel from playing video while it is off
  screen.

  The widget sits ~1970px down the PDP -- three screens below the fold on a
  phone -- and starts playing its active slide as soon as it builds, which on a
  normal visit means video decoding for something nobody has scrolled to.

  There is no autoplay attribute to remove: the videos render with
  autoplay=false and LoudCrowd calls play() itself. So instead we listen for
  the play event and pause again whenever the widget is out of view. Once it
  scrolls into view we stop interfering and the carousel behaves normally.

  The videos live three shadow roots down (shopwith-video-carousel-block >
  loudcrowd-carousel > loudcrowd-media > loudcrowd-video), all open, so they
  are reachable -- but they are built asynchronously, hence the polling window.
*/
(function () {
  var HOST_TAG = 'shopwith-video-carousel-block';
  var POLL_MS = 500;
  var POLL_LIMIT = 40; // ~20s of widget build time
  var visible = false;
  var guarded = new WeakSet();

  function collectVideos(root, out) {
    if (!root || !root.querySelectorAll) return out;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.tagName === 'VIDEO') out.push(el);
      if (el.shadowRoot) collectVideos(el.shadowRoot, out);
    }
    return out;
  }

  function videosFor(host) {
    return collectVideos(host.shadowRoot || host, []);
  }

  function guard(host) {
    var vids = videosFor(host);
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (guarded.has(v)) continue;
      guarded.add(v);
      v.addEventListener('play', onPlay);
      if (!visible && !v.paused) v.pause();
    }
  }

  function onPlay(e) {
    if (!visible) e.target.pause();
  }

  function start(host) {
    if (!('IntersectionObserver' in window)) return; // leave the widget alone

    new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        visible = entries[i].isIntersecting;
      }
      if (!visible) {
        var vids = videosFor(host);
        for (var j = 0; j < vids.length; j++) vids[j].pause();
      }
    }, { rootMargin: '200px 0px' }).observe(host);

    guard(host);
    var tries = 0;
    var timer = setInterval(function () {
      guard(host);
      if (++tries >= POLL_LIMIT) clearInterval(timer);
    }, POLL_MS);
  }

  function waitForHost() {
    var host = document.querySelector(HOST_TAG);
    if (host) return start(host);

    var mo = new MutationObserver(function () {
      var found = document.querySelector(HOST_TAG);
      if (found) {
        mo.disconnect();
        start(found);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForHost);
  } else {
    waitForHost();
  }
})();
